import React from 'react';
import noop from 'lodash/noop';
import classNames from 'classnames';
import Button from '../button';
import { ButtonColor } from '../button/enum';
export default function TransferOperation(props) {
    const { moveToLeft = noop, moveToRight = noop, leftArrowText = '', rightArrowText = '', leftActive, rightActive, className, multiple, oneWay, } = props;
    const customLeftClass = classNames(`${className}-custom-left-active`, {
        [`${className}-custom-left-disable`]: !leftActive,
    });
    const customRightClass = classNames(`${className}-custom-left-active`, {
        [`${className}-custom-left-disable`]: !rightActive,
    });
    if (multiple) {
        let leftArrowBtn;
        let rightArrowBtn;
        if (typeof leftArrowText === 'string') {
            leftArrowBtn = (React.createElement(Button, { color: leftActive ? ButtonColor.primary : ButtonColor.default, disabled: !leftActive, onClick: moveToLeft, icon: 'navigate_before' }, leftArrowText));
        }
        else {
            leftArrowBtn = (React.createElement("div", { className: customLeftClass, onClick: leftActive ? moveToLeft : undefined }, leftArrowText));
        }
        if (typeof rightArrowText === 'string') {
            rightArrowBtn = (React.createElement(Button, { color: rightActive ? ButtonColor.primary : ButtonColor.default, disabled: !rightActive, onClick: moveToRight, icon: 'navigate_next' }, rightArrowText));
        }
        else {
            rightArrowBtn = (React.createElement("div", { className: customRightClass, onClick: rightActive ? moveToRight : undefined }, rightArrowText));
        }
        return (React.createElement("div", { className: className },
            oneWay ? null : leftArrowBtn,
            rightArrowBtn));
    }
    return null;
}
